import { all } from 'redux-saga/effects';
import { watchCreate } from './create';
import { watchList } from './list';

export function* watchMedicalGroups() {
  yield all([watchCreate(), watchList()]);
}
